// extracted by mini-css-extract-plugin
export var paginationNumber = "index-module--pagination-number--c1DNL";
export var active = "index-module--active--gMPeY";